import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import { CategoriesService } from 'src/app/shared/services/wordpress-api/categories.service';
import { PostsService } from 'src/app/shared/services/wordpress-api/posts.service';

interface Mcateory {
  name: string;
  code: string;
}
@Component({
  selector: 'app-blog-layout',
  templateUrl: './blog-layout.component.html',
  styleUrls: ['./blog-layout.component.scss'],
})
export class BlogLayoutComponent implements OnInit {
  public CategoryListing: UntypedFormGroup;
  categoryRequestData: any;
  page: any = 1;
  per_page: any = 12;
  noMore: boolean = false;
  search: any;
  author: any;
  offset: any;
  order: any = 'desc';
  orderby: any = 'date';
  status: any = 'publish';
  tags: any;
  viewAll: Boolean = true;
  title: any;
  categoryData: any = [];
  categoryList: [];
  McategoryList: Mcateory[];
  McategoryVal: Mcateory;
  category: string;
  categoryId: any;
  rowsPerPageOptions = ['24', '48', '72', '96'];
  paginationRequest = {
    field: 'name',
    order: 1,
    rows: 24,
    page: 1,
    filter: {},
    totalRecords: 0,
  };
  isFilterVisible: boolean = true;
  deviceType: string;

  constructor(
    private categoriesService: CategoriesService,
    private postsService: PostsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.deviceType = localStorage.getItem('deviceType');
    if (this.deviceType === 'mobile') {
      this.isFilterVisible = false;
    }

    this.route.paramMap.subscribe((params) => {
      this.category = params.get('category');
      if (
        this.category !== null &&
        this.category !== undefined &&
        this.category !== ''
      ) {
        this.getCategoryId(this.category);
      } else {
        this.getBlogList('');
      }
    });
    this.CategoryListing = new UntypedFormGroup({
      McategoryVal: new UntypedFormControl('', [Validators.required]),
    });
  }

  onScroll(event) {
    let page = this.page;
    if (page * 1000 < event.currentScrollPosition) {
      this.page = this.page+1;
      this.paginationRequest.page = this.page+1;
      if(this.noMore == false){
        this.getBlogList(this.categoryId);
      }
    }
  }

  ngOnInit(): void {
    this.getCategoryList();
  }

  categoryListItem(slug) {
    this.router.navigate(['/blogs/category/' + slug]);
  }

  getCategoryId(slug) {
    this.categoryId =
      this.categoriesService.getCatSlugFromLocalStorage(slug).id;
    this.getBlogList(this.categoryId);
  }

  getCategoryList() {
    this.categoryList = this.categoriesService.getCategoriesFromLocalStorage();
    this.categoriesService
      .getCategories(1)
      .then((data: any) => {
        if(JSON.stringify(data) != JSON.stringify(this.categoryList))
        {
          this.categoryList = data;
          this.McategoryList = data.map((element: any) => {
            return {
              name: element.name,
              code: element.slug,
            };
          });
        }
      })
      .catch((err: any) => {});
  }

  getBlogList(category) {
    let queryParamsString = '?';
    if (this.page) {
      queryParamsString += 'page=' + this.page;
    }
    if (this.per_page) {
      queryParamsString += '&per_page=' + this.per_page;
    }
    if (this.search) {
      queryParamsString += '&search=' + this.search;
    }
    if (this.author) {
      queryParamsString += '&author=' + this.author;
    }
    if (this.offset) {
      queryParamsString += '&offset=' + this.offset;
    }
    if (this.order) {
      queryParamsString += '&order=' + this.order;
    }
    if (this.orderby) {
      queryParamsString += '&orderby=' + this.orderby;
    }
    if (this.status) {
      queryParamsString += '&status=' + this.status;
    }
    if (category) {
      queryParamsString += '&categories=' + category;
    }
    if (this.tags) {
      queryParamsString += '&tags=' + this.tags;
    }

    this.postsService.getPosts(queryParamsString).then(
      (data: any) => {
        this.categoryData = [...this.categoryData,...data];
        // this.getCategoryList();
        if (this.categoryData == null) {
          this.noMore = true;
        }
      },
      (err) => {
        if(err.error.code == 'rest_post_invalid_page_number'){
          this.noMore = true;
        }
        console.log(err);
      }
    );
  }

  onChange(event) {
    this.categoryListItem(event.value);
  }

  toggleFilterView() {
    this.isFilterVisible = !this.isFilterVisible;
  }
}
